export default "__VITE_ASSET__9e6761ba__"